import { Component, Injector, Input, OnInit } from '@angular/core';
import { FranceInvestmentComparablesRow } from '../../models/franceinvestmentcomparablesrow';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * FranceInvestmentComparables Widget
 */
@Component({
  selector: 'france-investment-comparables-widget',
  templateUrl: './france-investment-comparables-widget.component.html',
  styleUrls: ['./france-investment-comparables-widget.component.scss']
})
export class FranceInvestmentComparablesWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  * @param widgetService WidgetService
  */
  constructor(injector: Injector) {
    super(injector, 'franceInvestmentComparables', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("franceInvestmentComparables", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('franceInvestmentComparables');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('franceInvestmentComparables', this.getReport());
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Sufix for price per area values
   */
  get pricePerAreaSuffix() {
    return `/${this.unitOfArea}`;
  }

  /**
   * Add new row
   */
  addRow() {
    if (!this.widgetData.rows) {
      this.widgetData.rows = [];
    }
    this.widgetData.rows.push(new FranceInvestmentComparablesRow());
    this.forceDirty();
  }

  /**
   * Remove row
   * @param row {FranceInvestmentComparablesRow} Row to remove
   */
  removeRow(row: FranceInvestmentComparablesRow) {
    const index = this.widgetData.rows.indexOf(row, 0);
    if (index > -1) {
      this.widgetData.rows.splice(index, 1);
      this.forceDirty();
    }
  }
}
